import { useLocation } from 'react-router-dom';
import { useApplicationContext } from '../modules/context/ApplicationContext/ApplicationContext';

export const useIsReturningFromChildRoute = () => {
  const { pathname } = useLocation();
  const { previousLocation } = useApplicationContext();

  return !!previousLocation?.startsWith(`${pathname}/`);
};
